import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authFetch, dataFetch } from '../../api';
import { useAuth } from '../../context/AuthContext';
import { ROLES } from '../../data/roles';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Callback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const res = await authFetch('get-session');
        if (res?.data?.user) {
          const userId = res.data.user.id;
          const email = res.data.user.email;
          localStorage.setItem('user_id', userId);

          // --- Accept Invite Logic ---
          try {
            if (email) {
              const empRes = await dataFetch(`read/employees?email=${encodeURIComponent(email)}`);
              if (empRes?.status === 'success' && empRes.data && empRes.data.length > 0) {
                const emp = empRes.data[0];
                if (emp.inviteStatus === 'Invited') {
                  await dataFetch(`update/employees/${emp.id}`, {
                    method: 'PUT',
                    body: JSON.stringify({
                      ...emp,
                      inviteStatus: 'Active',
                      user_id: userId
                    })
                  });
                }
              }
            }
          } catch (err) {
            console.error('Invite accept failed:', err);
          }

          const mappedUser = await login(res.data.user);
          const role = mappedUser.role;
          
          if (role === ROLES.ADMINISTRATOR || role === ROLES.IT_SECURITY_ADMIN || role === 'Admin') {
            navigate('/', { replace: true });
          } else {
            let defaultPath = '/';
            if (role === ROLES.EMPLOYEE || role === 'Learner' || role === 'user') {
              defaultPath = '/employee/dashboard';
            } else if (role === ROLES.MANAGER) {
              defaultPath = '/my-team';
            }

            let fromPath = location.state?.from?.pathname;
            
            // Clear the "from" path if the user explicitly clicked "Logout" recently
            if (sessionStorage.getItem('manual_logout') === 'true') {
              fromPath = null;
              sessionStorage.removeItem('manual_logout');
            }

            // If no valid from match or if it's the root (which employees don't have access to), use defaultPath
            if (!fromPath || fromPath === '/') {
              fromPath = defaultPath;
            }

            navigate(fromPath, { replace: true });
          }
        } else {
          setError('Failed to authenticate with Google. Please try again.');
          setTimeout(() => navigate('/login'), 3000);
        }
      } catch (err) {
        setError('An error occurred during authentication.');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    handleCallback();
  }, [navigate, login, location]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="text-center max-w-md w-full bg-white rounded-2xl shadow-xl border border-slate-100 p-8">
        {error ? (
          <div>
            <SafeIcon icon={FiIcons.FiAlertCircle} className="text-4xl text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-slate-800 mb-2">Authentication Failed</h2>
            <p className="text-slate-600 mb-4">{error}</p>
            <p className="text-sm text-slate-500 animate-pulse">Redirecting to login...</p>
          </div>
        ) : (
          <div>
            <SafeIcon icon={FiIcons.FiLoader} className="text-4xl text-[#00E5FF] mx-auto mb-4 animate-spin" />
            <h2 className="text-xl font-bold text-slate-800 mb-2">Authenticating...</h2>
            <p className="text-slate-500">Please wait while we complete your sign in.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Callback;